import * as React from 'react'
import clsx from 'clsx'

import styles from './SelectDiv.module.css'

export interface SelectDivProps extends React.HTMLAttributes<HTMLDivElement> {
  invalid?: boolean
  disabled?: boolean
  children: React.ReactNode
}
export const SelectDiv = React.forwardRef<HTMLDivElement, SelectDivProps>(
  (props, ref) => {
    const {
      className,
      children,
      onClick,
      disabled = false,
      invalid = false,
      ...SelectDivProps
    } = props
    const classes = clsx(
      'focus:ring-4 focus:ring-white focus:ring-opacity-30 overflow-hidden bg-white py-2 pl-3 rounded-lg',
      styles.selectDiv,
      className
    )

    function handlePress(e: React.KeyboardEvent<HTMLDivElement>) {
      if (e.key === 'Enter') {
        onClick(e as any)
        return
      }
    }

    return (
      <div
        tabIndex={0}
        role="combobox"
        aria-controls=""
        aria-expanded="false"
        aria-haspopup="true"
        aria-disabled={disabled}
        aria-invalid={invalid}
        className={classes}
        onClick={disabled ? () => {} : onClick}
        onKeyPress={disabled ? () => {} : handlePress}
        {...SelectDivProps}
        ref={ref}
      >
        {children}
      </div>
    )
  }
)

SelectDiv.displayName = 'SelectDiv'
